import React from 'react';
import { useState } from "react";
import { useApp, getEndpointFunc } from '../../context/AppContext.jsx';

import { useTranslation } from "react-i18next";
import { MyButton } from "../../component/ui/UI.jsx";
import { MyPanel, MyHead1, MyHead2, MyInputLabel, MyTextArea } from '../../component/ui/UI.jsx';
import { restPost } from "@MyLib/System/Rest.js";

export const SupportForm = () =>
{
	const { t } = useTranslation();
	const {running, setYesNoModal} = useApp();

	const [email, setEmail] = useState("");
	const [message, setMessage] = useState("");
	const messageMax = 400;

	const onClick = async () => {
		if (message.length < 1) {
			return;
		}
		if (messageMax < message.length) {
			setYesNoModal({
				body: <div>{t("SupportForm_Attention").replace("{0}", messageMax)}</div>,
				onClose: () => {
					setYesNoModal(null);
				},
				hideNo: true
			});
			return;
		}

		running.inc();
		const res = await restPost(`${getEndpointFunc()}/contact`, {
			email: email,
			message: message
		});
		if (res.status == 200) {
			setMessage("");
		}
		running.dec();
	};

	return (
		<div className="d-flex flex-column p-1 gap-1">
			<MyPanel>
				<MyHead1>{t("Option_SupportForm")}</MyHead1>
				<p className="text-muted mb-4">
					{t("SupportForm_Desc")}
				</p>
				<div className="mb-3">
					<MyHead2>{t("SupportForm_Email")}</MyHead2>
					<MyInputLabel
						placeholder={t("SupportForm_Email")}
						value={email}
						setValue={setEmail}
					/>
				</div>
				<div className="mb-3">
					<MyHead2>{t("SupportForm_Message")}</MyHead2>
					<MyTextArea
						placeholder={t("SupportForm_Attention").replace("{0}", messageMax)}
						rows="4"
						value={message}
						setValue={setMessage}
						maxLength={messageMax}
					/>
				</div>
				<MyButton onClick={onClick} text={t("Common_OK")} />
			</MyPanel>
		</div>
	);
};
